import authService from './authService';

let BASE_URL = process.env.REACT_APP_API_URL;

async function loadConfig() {
  try {
    const response = await fetch("/config.json");
    const config = await response.json();
    BASE_URL = config.API_URL || BASE_URL;
  } catch (error) {
    console.error("Failed to load config.json. Using default .env API URL", error);
  }
}

loadConfig().then(() => {});

// Function to handle fetch requests
export async function fetchAllQuestionsAssessment( options: RequestInit = {}): Promise<any> {
 
  try {
    const response = await authService.apiCall(`${BASE_URL}/questions`, {
      ...options,
    
    });

    const data = await response.json();

    if (!response.ok ) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      //console.log("Failed to fetch");
    }
    return data;
  } catch (error: any) {
  
  }
}



export async function getQuestionsPaged(query: string = "", perPage: number = 10, pageNo: number = 0, options: RequestInit = {}): Promise<any> {
  const params = new URLSearchParams();
  if (query) params.set('query', query);
  params.set('perPage', String(perPage));
  params.set('pageNo', String(pageNo));
  const url = `${BASE_URL}/questions/find-all-paginated?${params.toString()}`;
  try {
    const response = await authService.apiCall(url, {
      ...options,
      method: options.method || 'GET'
    });
    const data = await response.json();
    if (!response.ok) {
      if (response.status === 401 || response.status === 403 || data.message === 'Forbidden access') {
        throw new Error('Forbidden: You do not have permission to access this resource.');
      }
      throw new Error(data?.message || 'Failed to fetch');
    }
    return data; // { data, totalPages, totalCount }
  } catch (error: any) {
    throw new Error(error);
  }
}

export async function createQuestionAssessment(body:any) {
  try{


   const response = await authService.apiCall(`${BASE_URL}/questions`, {
       method: "POST",
     
       body: JSON.stringify(body),
     
   });


   const data = await response.json();
   if (!response.ok || !data.success) {
       if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
           throw new Error("Forbidden: You do not have permission to access this resource.");
       }
       //console.log("Failed to fetch");
   }
   return data;
} catch (error: any) {
   //console.log(error);
}
}



export async function createQuestion(body: any) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/bank-questions`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Failed to fetch");
  }
}

export async function fetchAllDataApi(options: RequestInit = {}): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/bank-questions`, { ...options });
    const data = await response.json();
    if (!response.ok) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Failed to fetch");
  }
}

export async function fetchDataApi(url: string, options: RequestInit = {}): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/${url}`, { ...options });
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Failed to fetch");
  }
}

export async function createSurvey(body: any) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/publicSurvey`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Failed to fetch");
  }
}

export async function deleteSurveyApi(id: string): Promise<void> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/publicSurvey/${id}`, {
      method: 'DELETE',
    });
    if (!response.ok) {
      throw new Error('Failed to delete survey');
    }
    return response.json();
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to delete survey');
  }
}



export async function updateSurveyAssessmentApi(surveyAssessmentId: string, body: any): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/survey-assessment/${surveyAssessmentId}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    });

    const data = await response.json();
    
    if (!response.ok) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error(data.message || "Failed to update survey assessment");
    }

    // Handle both wrapped and direct responses
    if (data.success !== undefined) {
      // Wrapped response with success property
      if (!data.success) {
        throw new Error(data.message || "Update failed");
      }
      return data;
    } else {
      // Direct response (no success wrapper) - treat as success
      return { success: true, data: data, message: "Survey assessment updated successfully" };
    }
  } catch (error: any) {
    console.error("Error in updateSurveyAssessmentApi:", error);
    throw error;
  }
}

export async function deleteQuestionApi(id: string): Promise<void> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/bank-questions/${id}`, {
      method: 'DELETE',
    });
    if (!response.ok) {
      throw new Error('Failed to delete question');
    }
    return response.json();
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to delete question');
  }
}


export async function fetchQuestionByReference(id: string): Promise<any> {
  try {
    const response = await authService.apiCall(
      `${BASE_URL}/bank-questions/by-reference?referenceId=${encodeURIComponent(id)}`,
      { method: 'GET' }
    );
    const data = await response.json();
    if (!response.ok) {
      if (response.status === 401 || response.status === 403 || data.message === 'Forbidden access') {
        throw new Error('Forbidden: You do not have permission to access this resource.');
      }
      throw new Error('Failed to fetch');
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || String(error));
  }
}


/**
 * Send/Approve a public survey
 * @param surveyId - The ID of the survey to send/approve
 * @param body - Optional body data for the approval request
 * @returns Promise<any> - The API response
 */
export async function sendPublicSurvey(surveyId: string, body?: any): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/publicSurvey/${surveyId}/send`, {
      method: 'POST',
      body: body ? JSON.stringify(body) : undefined,
    });
    const data = await response.json();

    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === 'Forbidden access') {
        throw new Error('Forbidden: You do not have permission to access this resource.');
      }
      throw new Error(data.message || 'Failed to send/approve survey');
    }

    return data;
  } catch (error: any) {
    console.error('Error in sendPublicSurvey:', error);
    throw error;
  }
}

/**
 * Approve a public survey
 * @param surveyId - The ID of the survey to approve
 * @param body - Optional body data for the approval request
 * @returns Promise<any> - The API response
 */
export async function approvePublicSurvey(surveyId: string, body?: any): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/publicSurvey/${surveyId}/approve`, {
      method: 'POST',
      body: body ? JSON.stringify(body) : undefined,
    });
    const data = await response.json();

    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === 'Forbidden access') {
        throw new Error('Forbidden: You do not have permission to access this resource.');
      }
      throw new Error(data.message || 'Failed to approve survey');
    }

    return data;
  } catch (error: any) {
    console.error('Error in approvePublicSurvey:', error);
    throw error;
  }
}



export async function getSurveyQuestionByQuarter(
  riskId: any,
  quarter: string,
  year: number
): Promise<any> {
  try {
    const response = await authService.apiCall(
      `${BASE_URL}/survey-assessment/${riskId}/quarter/${quarter}/year/${year}`,
      { method: 'GET' }
    );
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Failed to fetch");
  }
}

export async function getSurveyQuestionByQuarterByPage(
  riskId: any,
  quarter: string,
  year: number,
  page: number,
  size: number
): Promise<any> {
  try {
    const response = await authService.apiCall(
      `${BASE_URL}/survey-assessment/${riskId}/quarter/${quarter}/year/${year}/page/${page}/size/${size}`,
      { method: 'GET' }
    );
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Failed to fetch");
  }
}

export async function assesstQuestion(body: any): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/survey-assessment`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Failed to fetch");
  }
}

export async function getRCSAByPage(
  quarter: string,
  year: number,
  page: number,
  pageSize: number
): Promise<any> {
  try {
    const response = await authService.apiCall(
      `${BASE_URL}/survey-assessment/compliance-data/quarter/${quarter}/year/${year}/page/${page}/size/${pageSize}`,
      { method: 'GET' }
    );
    const data = await response.json();
    if (!response.ok) {
      if (response.status === 401 || response.status === 403 || data?.message === 'Forbidden access') {
        throw new Error('Forbidden: You do not have permission to access this resource.');
      }
      throw new Error(data?.message || 'Failed to fetch');
    }
    if (data && typeof data === 'object' && data.success === false) {
      throw new Error(data.message || 'Failed to fetch RCSA data');
    }
    return data;
  } catch (error: any) {
    console.error('Error in getRCSAByPage:', error);
    throw new Error(error?.message || 'Failed to fetch');
  }
}

export async function updateSurveyApi(id: any, body: any): Promise<void> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/publicSurvey/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to update");
    }
    return data;
  } catch (error: any) {
    console.error("Error in updateSurveyApi:", error);
    throw new Error(error?.message || "Failed to update risk");
  }
}

export async function uploadExcelForRCSA(file: File) {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const response = await authService.apiCall(`${BASE_URL}/survey-assessment/excel`, {
      method: 'POST',
      body: formData,
    });
    if (!response.ok) {
      throw new Error('Failed to upload Excel file');
    }
    return response.json();
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to upload Excel file');
  }
}

export async function uploadExcelForRiskProfile(file: File) {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const response = await authService.apiCall(
      `${BASE_URL}/survey-assessment/excelForRiskProfile`,
      { method: 'POST', body: formData }
    );
    if (!response.ok) {
      throw new Error('Failed to upload Excel file');
    }
    return response.json();
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to upload Excel file');
  }
}

export async function fetchOneSurveyApi(url: string, options: RequestInit = {}): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/${url}`, { ...options });
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    console.error("Error in fetchOneSurveyApi:", error);
    throw new Error(error?.message || "Failed to fetch");
  }
}

export async function updateQuestionApi(id: string, data: any): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/bank-questions/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(result?.message || 'Failed to update question');
    }
    return result;
  } catch (error: any) {
    console.error('Error in updateQuestionApi:', error);
    throw new Error(error?.message || 'Failed to update question');
  }
}

export async function fetchOneQuestionApi(url: string, options: RequestInit = {}): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/${url}`, { ...options });
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    console.error("Error in fetchOneQuestionApi:", error);
    throw new Error(error?.message || "Failed to fetch");
  }
}

export async function fetchBankQuestionsApi(
  quarter: string,
  year: string,
  options: RequestInit = {}
): Promise<any> {
  const query = new URLSearchParams({ quarter, year }).toString();
  try {
    const response = await authService.apiCall(
      `${BASE_URL}/bank-questions/with-controls?${query}`,
      { ...options, method: (options.method as string) || 'GET' }
    );
    const text = await response.text();
    let data: any = {};
    if (text?.trim()) {
      try {
        data = JSON.parse(text);
      } catch {
        throw new Error('Invalid JSON response from server.');
      }
    }
    if (!response.ok) {
      if (
        response.status === 401 ||
        response.status === 403 ||
        data.message === 'Forbidden access'
      ) {
        throw new Error('Forbidden: You do not have permission to access this resource.');
      }
      throw new Error(data?.message || 'Failed to fetch bank questions.');
    }
    return data && typeof data.data !== 'undefined'
      ? data
      : { data: Array.isArray(data) ? data : [] };
  } catch (error: any) {
    throw new Error(error?.message || 'Unexpected error');
  }
}

/** Request body for updating a question category. */
export interface UpdateQuestionCategoryBody {
  en_name: string;
  ar_name: string;
}

/**
 * Updates a question category by UUID.
 * PATCH /question-categories/<category-uuid>
 * API returns the updated category object (id, en_name, ar_name, ...) on 200; no "success" wrapper.
 */
export async function updateQuestionCategoryApi(
  categoryUuid: string,
  body: UpdateQuestionCategoryBody
): Promise<any> {
  try {
    const response = await authService.apiCall(
      `${BASE_URL}/question-categories/${categoryUuid}`,
      {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      }
    );
    const data = await response.json();
    if (!response.ok) {
      if (
        response.status === 401 ||
        response.status === 403 ||
        (data && data.message === "Forbidden access")
      ) {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error(data?.message || "Failed to update question category");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Failed to update question category");
  }
}

/** Request body for updating a question (text) by UUID. */
export interface UpdateQuestionBody {
  en_questionText: string;
  ar_questionText: string;
}

/**
 * Updates a question by UUID.
 * PATCH /questions/<question-uuid>
 * API may return the updated question object on 200; do not require a "success" wrapper.
 */
export async function updateQuestionByUuidApi(
  questionUuid: string,
  body: UpdateQuestionBody
): Promise<any> {
  try {
    const response = await authService.apiCall(
      `${BASE_URL}/questions/${questionUuid}`,
      {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      }
    );
    const data = await response.json();
    if (!response.ok) {
      if (
        response.status === 401 ||
        response.status === 403 ||
        (data && data.message === "Forbidden access")
      ) {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error(data?.message || "Failed to update question");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Failed to update question");
  }
}
